export default {
  title: {
    workouts: 'Workouts',
    schema: 'Exercice',
    text: 'Description',
  },
  form: {
    difficulty: 'Difficulty',
  },
  group: {
    Endurance: 'Endurance',
    PowerEndurance: 'Power Endurance',
    Strength: 'Strength',
    Other: 'Other',
  },
  category: {
    AeroCap: 'Capacity aerobic',
    AeroPow: 'Power aerobic',
    AnCap: 'Capacity anaerobic',
    AnPow: 'Power anaerobic',
    Regeneration: 'Regeneration',
    FingerStrength: 'Finger strength',
    UpperStrength: 'Upper body strength',
    Power: 'Power',
    Other: 'Other',
    OpenClimbing: 'Open climbing',
    Flexibility: 'Flexibility',
    Technique: 'Technique',
  },
  activity: {
    climbing: 'route climbing',
    bouldering: 'bouldering',
    campus: 'campus',
    deadhang: 'deadhang',
    conditioning: 'conditioning',
    rest: 'rest',
  },
  label: {
    workouts_one: '1 workout',
    workouts_other: '{{count}} workouts',
    size: {
      '6mm': '6mm',
      '8mm': '8mm',
      '10mm': '10mm',
      '12mm': '12mm',
      '20mm': '20mm',
      slope: 'slope',
      pinch: 'pinch:',
    },
    crimp: {
      open: 'open hand',
      half: 'half crimp',
      full: 'full crimp',
    },
    fingerscrimp: {
      open: 'open hand',
      half: 'half crimp',
      full: 'full crimp',
    },
    fingers: {
      front2: '2 first fingers',
      front3: '3 first fingers',
      middle2: '2 middle finders',
      back2: '2 back fingers',
      back3: '3 back fingers',
    },
    restriction: {
      noshake: 'no shake',
      nohand: 'no hand',
      nofoot: 'no foot',
      onearm: 'un arm',
      withfoot: 'foot allowed',
    },
    conditioning: {
      shoulders: 'shoulders',
      biceps: 'biceps',
      triceps: 'triceps',
      quadriceps: 'quadriceps',
      forearm: 'forearm',
      finger: 'finger',
      pectoral: 'pectoral',
      abdominal: 'abdominal',
      thigh: 'thigh',
      cardio: 'cardio',
    },
    value_assess: 'assessment',
    value_max: 'max',
    value_pattern: 'as long as work',
  },
  summary: {
    rest: {
      intro: 'resting for',
      outro: 'between each',
      max: 'as much as necessary',
      pattern: 'as long as work',
      varyLabel: 'rest duration',
    },
    period: {
      intro: {
        period: 'continue the exercise',
        sequence: 'continue the sequence',
        repeat: 'continue the series',
      },
      max: {
        prefix: 'as',
        suffix: 'as possible',
      },
      value: {
        prefix: 'for',
        suffix: '',
      },
      varyLabel: 'exercice duration',
    },
    repeat: {
      intro: {
        period: 'repeat the exercise',
        sequence: 'repeat the sequence',
        repeat: 'repeat the series',
        other: 'repeat the exercise',
      },
      max: {
        prefix: 'as',
        suffix: 'as possible',
      },
      value: {
        prefix: '',
        suffix: 'time',
      },
      noRest: 'right away',
      intensity: {
        first: {
          rest: {
            inc: 'at each repetition, increase',
            dec: 'at each repetition, decrease',
            vary: 'at each repetition, vary',
          },
          noRest: {
            inc: 'by increasing',
            dec: 'by decreasing',
            vary: 'by varying',
          },
        },
        next: {
          rest: {
            inc: 'and increase',
            dec: 'and decrease',
            vary: 'and vary',
          },
          noRest: {
            inc: 'and by increasing',
            dec: 'and by decreasing',
            vary: 'and by varying',
          },
        },
        between: 'between',
        about: 'about',
        and: 'and',
        from: 'from',
        to: 'to',
        back: {
          rest: 'then return',
          noRest: 'then returning to',
        },
      },
      varyLabel: 'number of repeats',
    },
    sequence: {
      intro: {
        rest: 'perform the following exercises',
        noRest: 'perform the following exercises',
      },
      next: 'then,',
    },
    conditioning: {
      intro: 'do a strengthening exercise',
      intro_none: 'do a muscle strengthening exercise',
    },
    campus: {
      intro: 'on the Güllich pan, run the sequence',
    },
    restriction: {
      noshake: 'do not shake during the exercice',
      nohand: 'do the exercice without hand',
      onearm: 'do the exercice with a single arm',
      nofoot: 'do the exercice without foot',
      withfoot: 'you can put your feet on holes',
    },
    climbing: {
      intro: {
        single: {
          rest: 'climb a route',
          noRest: 'climb a route',
        },
        multiple: {
          rest: 'climb routes',
          noRest: 'climb routes',
        },
      },
      grade: 'with grade',
      varyGradeLabel: "the route's grade",
      varyLabel: 'the route',
    },
    bouldering: {
      intro: {
        single: {
          rest: 'climb a boulder',
          noRest: 'climb a boulder',
        },
        multiple: {
          rest: 'climb boulders',
          noRest: 'climb boulders',
        },
      },
      grade: 'with grade',
      varyGradeLabel: "the blouder's grade",
      varyLabel: 'the blouder',
    },
    deadhang: {
      intro: 'on a hangboard or campus board',
      intro_pinch: 'on a hangboard',
      intro_slope: 'on a hangboard',
      outro: 'and hang yourself',
      size: 'choose the holes',
      size_none: 'choose any hole',
      finger: 'with your',
      crimp: 'in position',
      rm: {
        prefix: 'weight down/up to get',
        suffix: 'of your maximum resistance',
      },
      rpe: {
        prefix: 'weight down/up to get Rate of Perceived Effort of',
        suffix: '',
      },
      assess: {
        prefix: 'progressively weight to get',
        suffix: 'your maximum level',
      },
    },
  },
}
